/**
 * Browser Detect (detect IE only)
 * returns version of IE or false, if browser is not Internet Explorer
 * add a class name to the html element. Useful for graceful degradation with css
 */

(function detectIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        var ieV = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        document.querySelector('html').className += 'ie ie-'+ieV;
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        var ieVTrident = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        document.querySelector('html').className += 'ie ie-'+ieVTrident;
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // IE 12 (aka Edge) => return version number
        var ieVEdge = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        document.querySelector('html').className += 'ie ie-'+ieVEdge;
    }

    // other browser
    return false;
})();